var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        "append-to-body": _vm.appendToBody,
        visible: _vm.innerVisible,
        title: _vm.title,
        width: "600px",
        "close-on-click-modal": false
      },
      on: {
        "update:visible": function($event) {
          _vm.innerVisible = $event
        },
        close: _vm.closeHandler
      }
    },
    [
      _c("check-result-display", {
        attrs: { "current-state": _vm.currentState, title: _vm.title }
      }),
      _vm.showFirstDetails
        ? _c(
            "div",
            { staticClass: "single-wrap" },
            [
              _c(
                "el-scrollbar",
                [
                  _vm.dataSource &&
                  _vm.dataSource.length > 0 &&
                  _vm.dataSource[0].details &&
                  _vm.dataSource[0].details.length > 0
                    ? _c("check-item-renderer", {
                        attrs: {
                          data: _vm.convertDataSource(_vm.dataSource[0].details)
                        }
                      })
                    : _vm._e()
                ],
                1
              )
            ],
            1
          )
        : _c(
            "div",
            { staticClass: "check-result-info" },
            [
              _c(
                "el-scrollbar",
                [
                  _c("dl", [
                    _c("dt", [
                      _c("label", [
                        _vm._v(_vm._s(_vm.$t("SeaExport.SequenceNumber")))
                      ]),
                      _c("span", [
                        _vm._v(_vm._s(_vm.$t("Message.OddNumbers")))
                      ]),
                      _c("p", [_vm._v(_vm._s(_vm.$t("Payment.status")))])
                    ])
                  ]),
                  _vm._l(_vm.dataSource, function(parent, index) {
                    return _c("simple-check-item-renderer", {
                      key: parent.jobNo + index,
                      attrs: {
                        index: index + 1,
                        data: parent,
                        node: _vm.checkNode,
                        "explain-data": _vm.explainData
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function(ref) {
                              var show = ref.show
                              return [
                                parent.details && parent.details.length > 0
                                  ? _c("check-item-renderer", {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value: show,
                                          expression: "show"
                                        }
                                      ],
                                      attrs: {
                                        data: _vm.convertDataSource(
                                          parent.details
                                        )
                                      }
                                    })
                                  : _vm._e()
                              ]
                            }
                          }
                        ],
                        null,
                        true
                      )
                    })
                  })
                ],
                2
              )
            ],
            1
          ),
      !!_vm.remark
        ? [
            _c("el-divider", { staticClass: "margin-bottom-12" }),
            _c("div", { domProps: { innerHTML: _vm._s(_vm.remark) } })
          ]
        : _vm._e(),
      _c(
        "span",
        { attrs: { slot: "footer" }, slot: "footer" },
        [
          _c(
            "el-button",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.showOneClickQuery,
                  expression: "showOneClickQuery"
                }
              ],
              attrs: { no: "oneClickQuery", type: "primary" },
              on: { click: _vm.oneClickQuery }
            },
            [_vm._v(_vm._s(_vm.$t("queryJob.OneClickQuery")))]
          ),
          _c(
            "el-button",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value:
                    _vm.currentState !== _vm.states.failure &&
                    _vm.currentState !== _vm.states.checking,
                  expression:
                    "currentState!==states.failure && currentState!==states.checking"
                }
              ],
              attrs: { no: "1", type: "primary" },
              on: { click: _vm.continueHandler }
            },
            [_vm._v(_vm._s(_vm.btn.confirmText))]
          ),
          _c(
            "el-button",
            {
              attrs: { no: "2", type: "danger" },
              on: { click: _vm.closeHandler }
            },
            [
              _vm._v(
                _vm._s(
                  _vm.currentState === _vm.states.failure
                    ? _vm.$t("CargoMsg.Cargo_Close")
                    : _vm.$t("CargoMsg.Cargo_Cancel")
                )
              )
            ]
          )
        ],
        1
      )
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }